// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.33.3
// source: chart.proto

/* eslint-disable */
import * as _m0 from "protobufjs/minimal";

export const protobufPackage = "com.tick2trade.api.chart";

export enum ChartType {
  CHART_TYPE_UNKNOWN = 0,
  CANDLESTICK = 2,
  LINE = 4,
  BAR = 6,
  AREA = 8,
  HISTOGRAM = 10,
  HEIKIN_ASHI = 12,
  FILL = 14,
  COLUMN = 16,
  RENKO = 18,
  LINE_BREAK = 20,
  KAGI = 22,
  POINT_AND_FIGURE = 24,
  RANGE = 26,
  HOLLOW_CANDLES = 28,
  HIGH_LOW = 30,
  BASELINE = 32,
  HLC_AREA = 34,
  VOLUME_CANDLESTICK = 36,
  STEP_LINE_CHART = 38,
  LINE_WITH_MARKERS = 40,
  UNRECOGNIZED = -1,
}

export function chartTypeFromJSON(object: any): ChartType {
  switch (object) {
    case 0:
    case "CHART_TYPE_UNKNOWN":
      return ChartType.CHART_TYPE_UNKNOWN;
    case 2:
    case "CANDLESTICK":
      return ChartType.CANDLESTICK;
    case 4:
    case "LINE":
      return ChartType.LINE;
    case 6:
    case "BAR":
      return ChartType.BAR;
    case 8:
    case "AREA":
      return ChartType.AREA;
    case 10:
    case "HISTOGRAM":
      return ChartType.HISTOGRAM;
    case 12:
    case "HEIKIN_ASHI":
      return ChartType.HEIKIN_ASHI;
    case 14:
    case "FILL":
      return ChartType.FILL;
    case 16:
    case "COLUMN":
      return ChartType.COLUMN;
    case 18:
    case "RENKO":
      return ChartType.RENKO;
    case 20:
    case "LINE_BREAK":
      return ChartType.LINE_BREAK;
    case 22:
    case "KAGI":
      return ChartType.KAGI;
    case 24:
    case "POINT_AND_FIGURE":
      return ChartType.POINT_AND_FIGURE;
    case 26:
    case "RANGE":
      return ChartType.RANGE;
    case 28:
    case "HOLLOW_CANDLES":
      return ChartType.HOLLOW_CANDLES;
    case 30:
    case "HIGH_LOW":
      return ChartType.HIGH_LOW;
    case 32:
    case "BASELINE":
      return ChartType.BASELINE;
    case 34:
    case "HLC_AREA":
      return ChartType.HLC_AREA;
    case 36:
    case "VOLUME_CANDLESTICK":
      return ChartType.VOLUME_CANDLESTICK;
    case 38:
    case "STEP_LINE_CHART":
      return ChartType.STEP_LINE_CHART;
    case 40:
    case "LINE_WITH_MARKERS":
      return ChartType.LINE_WITH_MARKERS;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChartType.UNRECOGNIZED;
  }
}

export function chartTypeToJSON(object: ChartType): string {
  switch (object) {
    case ChartType.CHART_TYPE_UNKNOWN:
      return "CHART_TYPE_UNKNOWN";
    case ChartType.CANDLESTICK:
      return "CANDLESTICK";
    case ChartType.LINE:
      return "LINE";
    case ChartType.BAR:
      return "BAR";
    case ChartType.AREA:
      return "AREA";
    case ChartType.HISTOGRAM:
      return "HISTOGRAM";
    case ChartType.HEIKIN_ASHI:
      return "HEIKIN_ASHI";
    case ChartType.FILL:
      return "FILL";
    case ChartType.COLUMN:
      return "COLUMN";
    case ChartType.RENKO:
      return "RENKO";
    case ChartType.LINE_BREAK:
      return "LINE_BREAK";
    case ChartType.KAGI:
      return "KAGI";
    case ChartType.POINT_AND_FIGURE:
      return "POINT_AND_FIGURE";
    case ChartType.RANGE:
      return "RANGE";
    case ChartType.HOLLOW_CANDLES:
      return "HOLLOW_CANDLES";
    case ChartType.HIGH_LOW:
      return "HIGH_LOW";
    case ChartType.BASELINE:
      return "BASELINE";
    case ChartType.HLC_AREA:
      return "HLC_AREA";
    case ChartType.VOLUME_CANDLESTICK:
      return "VOLUME_CANDLESTICK";
    case ChartType.STEP_LINE_CHART:
      return "STEP_LINE_CHART";
    case ChartType.LINE_WITH_MARKERS:
      return "LINE_WITH_MARKERS";
    case ChartType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum ChartSubType {
  CHART_SUB_TYPE_UNKNOWN = 0,
  SIMPLE = 1,
  STEP_LINE = 2,
  CURVED_LINE = 3,
  HOLLOW_CANDLESTICKS = 4,
  VOLUME_CANDLES = 5,
  HLC_AREA_CHART = 6,
  BASELINE_AREA = 7,
  HIGH_LOW_COLUMN = 8,
  CIRCLE_LINE = 9,
  CROSS_LINE = 10,
  UNRECOGNIZED = -1,
}

export function chartSubTypeFromJSON(object: any): ChartSubType {
  switch (object) {
    case 0:
    case "CHART_SUB_TYPE_UNKNOWN":
      return ChartSubType.CHART_SUB_TYPE_UNKNOWN;
    case 1:
    case "SIMPLE":
      return ChartSubType.SIMPLE;
    case 2:
    case "STEP_LINE":
      return ChartSubType.STEP_LINE;
    case 3:
    case "CURVED_LINE":
      return ChartSubType.CURVED_LINE;
    case 4:
    case "HOLLOW_CANDLESTICKS":
      return ChartSubType.HOLLOW_CANDLESTICKS;
    case 5:
    case "VOLUME_CANDLES":
      return ChartSubType.VOLUME_CANDLES;
    case 6:
    case "HLC_AREA_CHART":
      return ChartSubType.HLC_AREA_CHART;
    case 7:
    case "BASELINE_AREA":
      return ChartSubType.BASELINE_AREA;
    case 8:
    case "HIGH_LOW_COLUMN":
      return ChartSubType.HIGH_LOW_COLUMN;
    case 9:
    case "CIRCLE_LINE":
      return ChartSubType.CIRCLE_LINE;
    case 10:
    case "CROSS_LINE":
      return ChartSubType.CROSS_LINE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChartSubType.UNRECOGNIZED;
  }
}

export function chartSubTypeToJSON(object: ChartSubType): string {
  switch (object) {
    case ChartSubType.CHART_SUB_TYPE_UNKNOWN:
      return "CHART_SUB_TYPE_UNKNOWN";
    case ChartSubType.SIMPLE:
      return "SIMPLE";
    case ChartSubType.STEP_LINE:
      return "STEP_LINE";
    case ChartSubType.CURVED_LINE:
      return "CURVED_LINE";
    case ChartSubType.HOLLOW_CANDLESTICKS:
      return "HOLLOW_CANDLESTICKS";
    case ChartSubType.VOLUME_CANDLES:
      return "VOLUME_CANDLES";
    case ChartSubType.HLC_AREA_CHART:
      return "HLC_AREA_CHART";
    case ChartSubType.BASELINE_AREA:
      return "BASELINE_AREA";
    case ChartSubType.HIGH_LOW_COLUMN:
      return "HIGH_LOW_COLUMN";
    case ChartSubType.CIRCLE_LINE:
      return "CIRCLE_LINE";
    case ChartSubType.CROSS_LINE:
      return "CROSS_LINE";
    case ChartSubType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface ChartStyle {
  chartType: ChartType;
  color: string;
  thickness: number;
  opacity: number;
}

function createBaseChartStyle(): ChartStyle {
  return { chartType: 0, color: "", thickness: 0, opacity: 0 };
}

export const ChartStyle = {
  encode(message: ChartStyle, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.chartType !== 0) {
      writer.uint32(8).int32(message.chartType);
    }
    if (message.color !== "") {
      writer.uint32(18).string(message.color);
    }
    if (message.thickness !== 0) {
      writer.uint32(24).int32(message.thickness);
    }
    if (message.opacity !== 0) {
      writer.uint32(32).int32(message.opacity);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChartStyle {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChartStyle();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.chartType = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.color = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.thickness = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.opacity = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChartStyle {
    return {
      chartType: isSet(object.chartType) ? chartTypeFromJSON(object.chartType) : 0,
      color: isSet(object.color) ? globalThis.String(object.color) : "",
      thickness: isSet(object.thickness) ? globalThis.Number(object.thickness) : 0,
      opacity: isSet(object.opacity) ? globalThis.Number(object.opacity) : 0,
    };
  },

  toJSON(message: ChartStyle): unknown {
    const obj: any = {};
    if (message.chartType !== 0) {
      obj.chartType = chartTypeToJSON(message.chartType);
    }
    if (message.color !== "") {
      obj.color = message.color;
    }
    if (message.thickness !== 0) {
      obj.thickness = Math.round(message.thickness);
    }
    if (message.opacity !== 0) {
      obj.opacity = Math.round(message.opacity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChartStyle>, I>>(base?: I): ChartStyle {
    return ChartStyle.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChartStyle>, I>>(object: I): ChartStyle {
    const message = createBaseChartStyle();
    message.chartType = object.chartType ?? 0;
    message.color = object.color ?? "";
    message.thickness = object.thickness ?? 0;
    message.opacity = object.opacity ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
